"use client"

import { useState } from "react"
import { HiVolumeOff, HiVolumeUp } from "react-icons/hi"
import { ChevronRight, Home } from "lucide-react"

const BannerSectionFourth = () => {
    const [isMuted, setIsMuted] = useState(true)
    const fontStyle = { fontFamily: '"Plus Jakarta Sans", sans-serif' }

    const toggleMute = () => {
        setIsMuted(!isMuted)
    }

    return (
        <section className="relative w-full bg-white">

            {/* Animation */}
            <style dangerouslySetInnerHTML={{
                __html: `
                @keyframes bounce-horizontal {
                    0%, 100% { transform: translateX(0); animation-timing-function: cubic-bezier(0.8, 0, 1, 1); }
                    50% { transform: translateX(-25%); animation-timing-function: cubic-bezier(0, 0, 0.2, 1); }
                }
            `}} />

            {/* Container */}
            <div className="relative w-full px-4 xl:px-8 2xl:px-12 min-[1920px]:px-16">

                {/* Video banner */}
                <div className="relative w-full h-[280px] xl:h-[420px] 2xl:h-[550px] min-[1920px]:h-[750px] rounded-2xl overflow-hidden group">
                    <video
                        className="absolute inset-0 w-full h-full object-cover scale-105"
                        autoPlay
                        loop
                        muted={isMuted}
                        playsInline
                    >
                        <source src="/videos/BannerAbout.mp4" type="video/mp4" />
                    </video>

                    {/* Overlay */}
                    <div className="absolute inset-0 bg-black/20" />

                    {/* Breadcrumb */}
                    <div
                        className="hidden md:flex absolute top-2 left-2 xl:top-4 xl:left-4 2xl:top-5 2xl:left-5 min-[1920px]:top-8 min-[1920px]:left-8 items-center gap-1 text-white z-20"
                        style={fontStyle}
                    >
                        <Home className="size-3 xl:size-3.5 2xl:size-4 min-[1920px]:size-5" strokeWidth={2} />
                        <ChevronRight className="size-2.5 xl:size-3 2xl:size-3.5 min-[1920px]:size-4 opacity-70" />
                        <span className="text-[10px] xl:text-xs 2xl:text-[13px] min-[1920px]:text-base font-light tracking-wide">
                            Rovi Investment
                        </span>
                    </div>

                    {/* Tiêu đề */}
                    <div className="absolute bottom-10 2xl:bottom-16 min-[1920px]:bottom-24 left-1/2 -translate-x-1/2 w-full text-center px-4 z-20">
                        <h1 className="text-[#FFFFFF] text-2xl md:text-3xl xl:text-4xl 2xl:text-6xl min-[1920px]:text-8xl font-normal tracking-tight text-balance" style={fontStyle}>
                            Tiên phong dẫn lối
                        </h1>
                    </div>

                    {/* Nút bật/tắt âm thanh */}
                    <div className="absolute bottom-3 right-3 md:bottom-6 md:right-6 2xl:bottom-10 2xl:right-10 min-[1920px]:bottom-14 min-[1920px]:right-14 z-20 transition-opacity">
                        <button
                            onClick={toggleMute}
                            className="p-1.5 md:p-2 2xl:p-3 min-[1920px]:p-4 bg-black/40 backdrop-blur-md border border-white/20 rounded-full text-white hover:bg-black/60 transition-all"
                        >
                            {isMuted
                                ? <HiVolumeOff className="size-3.5 md:size-4 2xl:size-6 min-[1920px]:size-8" />
                                : <HiVolumeUp className="size-3.5 md:size-4 2xl:size-6 min-[1920px]:size-8" />
                            }
                        </button>
                    </div>
                </div>

                {/* Chỉ báo cuộn */}
                <div className="hidden md:block absolute bottom-30 right-0 -translate-x-1 -rotate-90 origin-bottom-right z-12 2xl:right-2 min-[1920px]:right-4 min-[1920px]:bottom-40">
                    <div className="flex items-center gap-2 text-black/60">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" className="w-5 h-5 2xl:w-6 2xl:h-6 min-[1920px]:w-8 min-[1920px]:h-8" style={{ animation: 'bounce-horizontal 1s infinite' }}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
                        </svg>
                        <p className="font-normal tracking-[0.12em] text-[10px] 2xl:text-xs min-[1920px]:text-sm uppercase whitespace-nowrap">
                            Scroll Down
                        </p>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default BannerSectionFourth